// Only server-marked homepage images participate; no global DOM observer.
(() => {
  const pending = new Set();
  let observer;
  let margin = 0;
  function load(image) {
    observer?.unobserve(image);
    pending.delete(image);
    const picture = image.closest('picture');
    picture?.querySelectorAll('source[data-nv-srcset]').forEach(source => {
      source.srcset = source.dataset.nvSrcset;
      source.removeAttribute('data-nv-srcset');
    });
    // Preserve native lazy/auto sizes so responsive product images use their
    // rendered width. The observer, rather than native lazy distance, gates src.
    if (image.dataset.nvSrcset) image.srcset = image.dataset.nvSrcset;
    if (image.dataset.nvSrc) image.src = image.dataset.nvSrc;
    image.removeAttribute('data-nv-src');
    image.removeAttribute('data-nv-srcset');
    image.removeAttribute('data-nv-deferred');
  }
  function observe() {
    observer?.disconnect();
    if (!('IntersectionObserver' in window)) {
      pending.forEach(load);
      return;
    }
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) load(entry.target); });
    }, { rootMargin: `${margin}px 0px` });
    pending.forEach(image => {
      if (image.isConnected) observer.observe(image);
      else pending.delete(image);
    });
  }
  function scan(root = document) {
    root.querySelectorAll('img[data-nv-deferred]').forEach(image => {
      if (pending.has(image)) return;
      pending.add(image);
      if (observer) observer.observe(image);
    });
    if (!observer) observe();
  }
  function enableAhead() {
    if (margin) return;
    margin = 300;
    observe();
  }
  scan();
  const hero = document.querySelector('main img[fetchpriority="high"]:not([data-nv-deferred])');
  if (!hero || hero.complete) enableAhead();
  else {
    hero.addEventListener('load', enableAhead, { once: true });
    hero.addEventListener('error', enableAhead, { once: true });
  }
  // A visitor who scrolls immediately must not wait for the hero download.
  window.addEventListener('scroll', enableAhead, { once: true, passive: true });
  ['shopify:section:load', 'filter:update', 'variant:update', 'dialog:open'].forEach(name => {
    document.addEventListener(name, () => scan());
  });
})();
